<script>
export default {
  name: 'Text',
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isTitle() {
      return this.componentData.type === 'title'
    },
    isSubtitle() {
      return this.componentData.type === 'subtitle'
    }
  },
  methods: {
    decodeHTMLEntities(str) {
      let element = document.createElement('div')
      if (str && typeof str === 'string') {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '')
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '')
        element.innerHTML = str
        str = element.textContent
        element.textContent = ''
      }
      return str
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <p
      v-if="!componentData.link"
      :class="[isTitle ? $style.isTitle : $style.isSubtitle]">
      {{ decodeHTMLEntities(componentData.text) }}
    </p>
    <p 
      v-if="componentData.link"
      :class="[isTitle ? $style.isTitle : $style.isSubtitle]">
      <a :href="componentData.link">{{ decodeHTMLEntities(componentData.text) }}</a>
    </p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  @extend %typography-medium;
  display: flex;
  justify-content: center;
  text-align: center;
  margin: $size-spacing-medium 0;
  padding: 1rem 0;

  h4 {
    @extend %typography-large;

    margin: 1rem 0 0 1rem;
    text-align: left;
  }

  p {
    margin: 0 1rem 0 1rem;
    text-align: left;
  }

}

.isTitle {
  font-size: 1.5em;
  font-weight: bold;
  text-align: center !important;
}

.isSubtitle {
  @extend %typography-medium;
  text-align: center !important;
  color: $dark-gray;
  padding: 0 .2rem;
  line-height: 1.5rem;
}

</style>
